import { callOrganizationServiceApi } from '../../../apis/organizationService';

/**
 * organization-service refuses more than this many distinct ids with a 400.
 * The service splits a longer list into requests of this size.
 */
export const LOCATION_COUNTS_MAX_IDS = 50;

/**
 * How many locations each identity can access, from organization-service.
 *
 * One item per distinct id, in request order, with 0 for an identity that has
 * no grants — so an id that organization-service does not know reads as 0, not
 * as missing.
 *
 * @param {string[]} identityIds - auth-service user ids
 * @returns {Promise<import('../types/User.api').IGetIdentityLocationCountsApiResponse>}
 */
export const getIdentityLocationCounts = (identityIds) =>
  callOrganizationServiceApi('get', 'admin/identities/location-counts', {
    params: { identityIds: identityIds.join(',') },
  });
